import { BLOG_GET_CATEGORIES_URL, BLOG_GET_URL } from '@/utils/api';
import { http } from '@/plugins/http';
import { getApiResponse } from '@/utils/helper';

export const fetchBlogPosts = (urlParams) => getApiResponse(() => http.get(`${BLOG_GET_URL}?${urlParams}`));

export const fetchBlogCategories = () => getApiResponse(() => http.get(BLOG_GET_CATEGORIES_URL));
